// extracted by mini-css-extract-plugin
module.exports = {"home_section_title":"HomeSectionTitle_home_section_title__1V6IK","title_text":"HomeSectionTitle_title_text__3Fmsg"};